module.exports = __webpack_public_path__ + "static/media/ic_wcag_animation.f229346b.svg";